module.exports = __webpack_public_path__ + "img/fuentes_de_alimentacion_on_machine.fdd5d7de.jpg";